import { DEFAULT_MAP_CENTER } from "../core/views/map/constants";

const devConfig = {
    routingEndpoint: "https://argon-dev-eu-west-1.gw.stratus-ps-rd.ops.hereapi.com/planning",
    COUNTRY_RULES: '/i/countryrules',
    defaultCenter: DEFAULT_MAP_CENTER,
}

const devConfigSK = {
    routingEndpoint: "https://argon-dev-eu-west-1.gw.stratus-ps-rd.ops.hereapi.com/planning",
    COUNTRY_RULES: '/i/countryrules',
    defaultCenter: { lat: 37.5665, lng: 126.9780 }, // Centered on Seoul, South Korea
    region: 'KR', // Required for South Korea - uses heremaps.kr endpoints
    defaultLanguage: 'ko', // Korean language for map labels
}

const prodConfig = {
    routingEndpoint: "https://argon-prd-eu-west-1.gw.stratus-ps-p.ops.hereapi.com/planning",
    COUNTRY_RULES: '/i/countryrules',
    defaultCenter: DEFAULT_MAP_CENTER,
}

const prodSkConfig = {
    routingEndpoint: "https://argon-prd-ap-northeast-2.gw.stratus-ps-p.ops.hereapi.com/planning",
    COUNTRY_RULES: '/i/countryrules',
    defaultCenter: { lat: 37.5665, lng: 126.9780 }, // Centered on Seoul, South Korea
    region: 'KR', // Required for South Korea - uses heremaps.kr endpoints
    defaultLanguage: 'ko', // Korean language for map labels
}

export const ENV = process.env.REACT_APP_ENV || 'dev';

let config;
switch (process.env.REACT_APP_ENV) {
    case 'prd-sk':
        config = prodSkConfig;
        break;
    case 'prd':
        config = prodConfig;
        break;
    case 'dev-sk':
        config = devConfigSK;
        break;
    case 'dev':
    default:
        config = devConfig;
        break;
}

export default config;